import { createContext, useContext, useEffect, useState } from "react";

/**
 * 상단바(Header) 우측 액션 주입용 컨텍스트.
 * 페이지가 useHeaderAction 으로 { label, onClick, disabled? } 를 등록하면
 * Header(비메인 페이지)에서 우측에 텍스트 버튼으로 노출된다. 미등록 시 아무것도 안 뜸(하위호환).
 */
const HeaderActionContext = createContext({ action: null, setAction: () => {} });

export function HeaderActionProvider({ children }) {
  const [action, setAction] = useState(null);
  return (
    <HeaderActionContext.Provider value={{ action, setAction }}>
      {children}
    </HeaderActionContext.Provider>
  );
}

// Header 가 우측 액션 값을 읽을 때 사용
export function useHeaderActionValue() {
  return useContext(HeaderActionContext).action;
}

/**
 * 페이지에서 우측 액션 등록. action 은 useMemo 등으로 안정화해 전달 권장.
 * 언마운트 시 자동 해제.
 */
export function useHeaderAction(action) {
  const { setAction } = useContext(HeaderActionContext);
  useEffect(() => {
    setAction(action || null);
    return () => setAction(null);
  }, [action, setAction]);
}
